export const REQUEST_TYPES = {
	GET_SKILLS: 'GET_ACCOUNT_SKILLS',
	GET_SKILLS_ACTIVE_IN_ACCOUNT: 'GET_SKILLS_ACTIVE_IN_ACCOUNT',
	DO_ADD_ACCOUNT_SKILLS: 'DO_ADD_ACCOUNT_SKILLS',
};
